import Vue from 'vue';

import {
  CustomInputRegion,
} from '@/components';

import _ from 'lodash';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  required,
  email,
  regex,
} from 'vee-validate/dist/rules';

export default {
  name: 'RegionDataForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    [CustomInputRegion.name]: CustomInputRegion,
  },
  props: {},
  data: () => ({
    search: '',
    cityId: '',
    citiesFiltered: [],
    changed: false,
    rules: 'required',
  }),
  computed: {
    searchWatcher: {
      get() {
        return this.searchWatch;
      },
      set(data) {
        this.setSearchWatch(data);
        return data;
      },
    },
    showMask() {
      return true;
    },
    ...mapGetters('appointment', {
      language: 'getLanguage',
      regionDataState: 'getRegionData',
      customerDataRaw: 'getCustomerDataRaw',
      searchWatch: 'getSearchWatch',
    }),
    ...mapGetters('city', {
      cities: 'getCities',
    }),
  },
  methods: {
    ...mapActions('city', {
      getCities: 'FETCH_DATA_CITIES',
    }),
    save() { },
    setValidationMessages() {
      // Vee-validate
      // Translations are added in the PersonalDataFormComponent
      extend('required', {
        ...required,
        message: Vue.prototype.$gettext('Validation - Required error'),
      });

      extend('email', {
        ...email,
        message: Vue.prototype.$gettext('Validation - Email error'),
      });

      extend('regex', {
        ...regex,
        message: Vue.prototype.$gettext('Validation - Regex error'),
      });

      extend('objectNotEmpty', {
        validate: (value) => {
          if (value !== 0) {
            return true;
          }
          return Vue.prototype.$gettext('Validation - Leasing company');
        },
      });
    },
    ...mapMutations('appointment', {
      setRegionData: 'SET_REGIONDATA',
      setPostcode: 'SET_POSTALCODE',
      setRegion: 'SET_REGION',
      setSearchWatch: 'SET_SEARCHWATCH',
    }),
    searchList: _.debounce(function () {
      this.search = this.searchWatch;
      this.setCities();
    }, 350),
    setCities() {
      if (this.search.length > 1) {
        const searchLowerCase = this.search.toLowerCase();
        this.citiesFiltered = this.cities.filter(c => c.City.toLowerCase().startsWith(searchLowerCase) || c.ZipCode.toString().startsWith(searchLowerCase));
      } else {
        this.citiesFiltered = [];
      }
    },
    searchCityKeybordEvents(e) {
      const elements = document.getElementsByClassName('a-search-button__result');
      if ((e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) || elements.length === 0) {
        return;
      }

      // Enter
      if (e.keyCode === 13) {
        const highlightElements = document.getElementsByClassName('highlight');
        if (highlightElements.length > 0) {
          this.cityId = highlightElements[0].getAttribute('data-id');
          const city = highlightElements[0].getAttribute('data-city');
          const zipCode = highlightElements[0].getAttribute('data-zip-code');
          const label = `${city} - ${zipCode}`;
          this.searchGaragesByCityId(this.cityId, label, zipCode);
        }
        return;
      }

      // Set current index
      let currentHighlightIndex = -1;
      for (let index = 0; index < elements.length; index += 1) {
        if (elements[index].classList.contains('highlight')) {
          currentHighlightIndex = index;
        }
      }

      // Clear all highlights
      for (let index = 0; index < elements.length; index += 1) {
        elements[index].classList.remove('highlight');
      }

      // Keydown
      if (e.keyCode === 40) {
        if (elements.length > currentHighlightIndex + 1) {
          elements[currentHighlightIndex + 1].classList.add('highlight');
        }
      }

      // Keyup
      if (e.keyCode === 38) {
        if (currentHighlightIndex > 0) {
          elements[currentHighlightIndex - 1].classList.add('highlight');
        }
        if (currentHighlightIndex === 0) {
          elements[0].classList.add('highlight');
        }
      }

      // Scrolltop
      const highlightElements = document.getElementsByClassName('highlight');
      if (highlightElements.length > 0) {
        const topPos = highlightElements[0].offsetTop;
        document.getElementsByClassName('a-search-button__results-list')[0].scrollTop = topPos;
      }
    },
    searchGaragesByCityId(cityId, label, postalCode, city) {
      this.setSearchWatch(postalCode);
      this.citiesFiltered = [];

      this.setPostcode(postalCode);
      this.setRegion(label);

      const setPostalCode = {
        state: postalCode,
        property: 'zipCode',
      };
      this.setRegionData(setPostalCode);

      const setCity = {
        state: city,
        property: 'city',
      };
      this.setRegionData(setCity);
    },
  },
  watch: {
    language() {
      this.setValidationMessages();
    },
    searchWatch() {
      this.searchList();
    },
  },
  created() {
    this.setValidationMessages();
    if (this.cities.length === 0) {
      this.getCities();
    }
  },
};
